import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { AlertTriangle, CalendarRange } from "lucide-react";

// Selettore unico "Anno di lavoro" + banner quando differisce dall'anno corrente
export const WorkYearBar = ({ year, years, currentYear, onChange, busy }) => {
  const other = year && currentYear && year !== currentYear;
  return (
    <div className={`mb-5 space-y-3 ${other ? "sticky top-16 z-30 bg-background/95 backdrop-blur py-2" : ""}`} data-testid="work-year-bar">
      <div className="flex flex-wrap items-center gap-3">
        <span className="text-sm font-medium flex items-center gap-1.5"><CalendarRange size={16} className="text-primary" /> Anno di lavoro</span>
        <Select value={year || ""} onValueChange={onChange} disabled={busy}>
          <SelectTrigger data-testid="work-year-select" className="bg-white w-52"><SelectValue placeholder="Scegli" /></SelectTrigger>
          <SelectContent>{years.map((y) => <SelectItem key={y} value={y}>{y}{y === currentYear ? " (corrente)" : ""}</SelectItem>)}</SelectContent>
        </Select>
        {busy && <span className="text-xs text-muted-foreground flex items-center gap-1.5" data-testid="work-year-loading"><span className="h-3.5 w-3.5 rounded-full border-2 border-primary border-t-transparent animate-spin" /> Caricamento…</span>}
        {!other && year && !busy && <span className="text-xs text-muted-foreground" data-testid="work-year-is-current">È l'anno corrente, visibile agli allievi</span>}
      </div>
      {other && (
        <div data-testid="work-year-banner" role="alert"
          className="rounded-lg border-2 border-amber-500 bg-amber-100 text-amber-900 px-4 py-3 text-sm font-semibold flex items-start gap-2 shadow-sm">
          <AlertTriangle size={18} className="shrink-0 mt-0.5" />
          <span>Stai lavorando sull'anno {year}: non è ancora visibile agli allievi (anno corrente: {currentYear}).</span>
        </div>
      )}
    </div>
  );
};
